/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var DataChartPieA1Icon32Regular = forwardRef('DataChartPieA1Icon32Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 32 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M16 3a1 1 0 0 0-1 1v12a1 1 0 0 0 1.5.866l10.392-6a1 1 0 0 0 .366-1.366A13 13 0 0 0 16 3Zm1 11.268V5.046a11 11 0 0 1 7.987 4.61L17 14.269Z" }),
        React.createElement("path", { d: "M11.416 6a1 1 0 0 0-.834-1.817 13 13 0 1 0 18.371 10.713 1 1 0 0 0-1.993.17 11 11 0 1 1-15.544-9.065Z" })));
});
